import { AccountTypes } from "../../../models/enum/account.enum";

export function isCreditType(type: string): boolean {
  return (
    type === AccountTypes.creditCard || type === AccountTypes.loan || type === AccountTypes.credit
  );
}

export function isMortgageType(type: string): boolean {
  return type === AccountTypes.mortgage;
}
